import FormField from "./FormField";

const rowCountToClass = {
  1: "one fields",
  2: "two fields",
  3: "three fields",
  4: "four fields",
  5: "five fields",
  6: "six fields",
};

const FormRow = ({
  cols,
  count,
  setSectionState,
  sectionState,
  searchFieldReset,
  setSearchFieldReset,
  section,
  tab,
}) => {
  return (
    <div className={rowCountToClass[count]}>
      {cols.map((col) => (
        <FormField
          key={col.scfCode}
          field={col}
          section={section}
          tab={tab}
          setSectionState={setSectionState}
          sectionState={sectionState}
          searchFieldReset={searchFieldReset}
          setSearchFieldReset={setSearchFieldReset}
        />
      ))}
    </div>
  );
};

export default FormRow;
